import React, { Component } from 'react';
import './About.module.css';

class About extends Component {
  componentDidMount() {
    this.runAboutScript();
  }

  runAboutScript() {
    const preTag = document.getElementById("myPreTag");
    // Create a copy button element
    const copyButton = document.createElement("span");
    copyButton.innerText = "Copy";
    copyButton.classList.add("copy-button");
    
    // Append the copy button to the <pre> tag
    preTag.appendChild(copyButton);

    
    // Add click event listener to the copy button
    copyButton.addEventListener("click", () => {
      // Hide the copy button temporarily
      copyButton.style.display = "none";
    
      // Create a range and select the text inside the <pre> tag
      const range = document.createRange();
      range.selectNode(preTag);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      try {
        // Copy the selected text to the clipboard
        document.execCommand("copy");
      
        // Alert the user that the text has been copied
        copyButton.innerText = "Copied!";
        setTimeout(function(){
          copyButton.innerText = "Copy";
        }, 2000);
      } catch (err) {
        console.error("Unable to copy text:", err);
      } finally {
        // Show the copy button again
        copyButton.style.display = "inline";
      
        // Deselect the text
        window.getSelection().removeAllRanges();
      }
    });
  }

  render() {
    return (
        <div className="mx-lg-5 mx-2 w-100">
            <div className="about_container mx-5">
                <span className="section_label text-shadow-active">ABOUT</span>
            </div>
            <div className="mx-lg-5 mt-lg-3">
                <div className="mx-lg-5">
                    <pre id="myPreTag" className="d-block">
                    class VOLT &#123; {'\n'}
                    {'    '}init () &#123;{'\n'}
                    {'        '}this.fullName = "VOLTAIRE REY UYCOQUE"{'\n'}
                    {'        '}this.email = "voltaireuycoque@gmail.com"{'\n'}
                    {'    '}&#125;{'\n'}
                    {'\n'}

                    {'    '}workExperience(workType) &#123;{'\n'}
                    {'        '}if (workType == .fullTime)&#123;{'\n'}
                    {'            '}return [{'\n'}
                    {'                '}&#123; "08/2021 - 06/2026" : "Mobile Team Captain/ Whitecloak Technologies Inc - UnionBank PH" &#125;,{'\n'}
                    {'                '}&#123; "06/2018" - "08/2021" : "Software Engineer / MobileMINDS Inc"&#125;,{'\n'}
                    {'                '}&#123; "04/2018 - 06/2018" : "OJT / Hartmann Crew Philippines" &#125;{'\n'}
                    {'            '}]{'\n'}
                    {'        '}&#125; else &#123; //Freelance or Part-time{'\n'}
                    {'            '}return [{'\n'}
                    {'                '}&#123; "06/2026 - NOW" : "iOS Developer/ Whitecloak Technologies Inc" &#125;,{'\n'}
                    {'                '}&#123; "11/2022 - 06/2023" : "iOS Developer/ 2DamCreative" &#125;,{'\n'}
                    {'                '}&#123; "10/2021" - "01/2023" : "Project Manager / Thinkthirsty"&#125;,{'\n'}
                    {'                '}&#123; "04/2018 - 06/2018" : "Fullstack Web / AR.ARR Media" &#125;{'\n'}
                    {'            '}]{'\n'}
                    {'        '}&#125;{'\n'}
                    {'    '}&#125;{'\n'} 
                    {'\n'}

                    {'    '}education() &#123;{'\n'}
                    {'        '}return [{'\n'}
                    {'                '}&#123; "06/2015 - 05/2019" : "Bachelor in Computer Science / Polytechnic University of the Phillipines" &#125;,{'\n'}
                    {'                '}&#123; "06/2011 - 03/2015" : "Caloocan High School"&#125;{'\n'}
                    {'        '}]{'\n'}
                    {'    '}&#125;{'\n'}
                    {'\n'}

                    {'    '}achievements()  &#123;{'\n'}
                    {'        '}return  &#123;{'\n'} 
                    {'             '}"Whitecloak Technologies Inc - UnionBank Philippines (2023)" : [ {'\n'} 
                    {'                    '}"Excellence in Internet Banking (The Portal) RBI Asia Trailblazer Awards",{'\n'} 
                    {'                    '}"Most Innovative Branch Offering (The Portal MC) RBI Asia Trailblazer Awards",{'\n'} 
                    {'                    '}"Best Customer Experience via Mobile and Internet Banking (The Portal) Digital CX Awards",{'\n'} 
                    {'                    '}"Best Corporate Mobile Application (The Portal) The Asset Triple A Digital Awards"{'\n'} 
                    {'             '}],{'\n'} 
                    {'             '}"Whitecloak Technologies Inc - UnionBank Philippines (2022)" : [{'\n'} 
                    {'                    '}"Productivity Achievement Award (The Portal DE & DAO) Heroes & Champion",{'\n'} 
                    {'                    '}"Highly Commended: Best Digital CX - Account Opening and Customer Onboarding CX Awards"{'\n'} 
                    {'             '}],{'\n'} 
                    {'        '}&#125;{'\n'}
                    {'    '}&#125;{'\n'}

                    {'\n'}
                    {'    '}skills() &#123;{'\n'}
                    {'        '}return [{'\n'}
                    {'             '}"HTML/CSS/JS", "Laravel", "Vue", "SQL", "MySQL", "PHP", "PWA", "Bootstrap"{'\n'}
                    {'             '}"Swift 3", "Swift 4", "Flutter", "Android (Java)", "Android (Kotlin)",{'\n'}
                    {'             '}"Firebase", "UI/UX", "Figma", "Sketch"{'\n'}
                    {'        '}];{'\n'}
                    {'    '}&#125;{'\n'}
                    &#125;{'\n'} 
                    </pre>
                </div>
            </div>
        </div>
    );
  }
}

export default About;